<template>
  <div
    v-loading.fullscreen.lock="isLoading"
    element-loading-text="資料上傳中～請稍候！"
  >
    <el-card>
      <div slot="header" style="font-size: 16px; font-weight: bold">
        <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
          返回
        </el-button>
            <el-divider direction="vertical"></el-divider>
        <span> 匯入書目 </span>
      </div>
      <el-row>
        <el-col :span="12">
          <div style="width: fit-content">
            <el-upload
              class="inline-block margin-right-20"
              ref="upload"
              action=""
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :auto-upload="false"
            >
              <!--file-list設定１次只能匯入１個檔案-->

              <el-button type="primary" icon="el-icon-folder-opened"
                >載入新Excel文件</el-button
              >
            </el-upload>
          </div>
        </el-col>
        <el-col :span="6" :offset="6">
          <el-button
            style="float: right; margin-right: 10px"
            class="darkblue"
            @click="exportExcel"
          >
            下載範例檔
          </el-button>

          <el-button
            type="warning"
            icon="el-icon-collection"
            @click="fileImport"
            :disabled="btImport()"
            >確認上傳</el-button
          >
          <!-- :disabled="correctDataCount == 0" -->
        </el-col>
      </el-row>

      <br />

      <el-row style="font-size: 20px; font-weight: bold">
        <div v-if="importGo">
          <span>載入結果：總共{{ dataCount }}筆/</span>
          <span style="color: green">正確{{ correctDataCount }}筆</span>
          <span>/</span>
          <span style="color: red">錯誤{{ inCorrectDataCount }}筆。</span>
        </div>
        <div v-if="!importGo">
          <span>上傳結果：總共{{ dataCount }}筆/</span>
          <span style="color: green"
            >成功{{ dataCount - resdata.length }}筆</span
          >
          <span>/</span>
          <span style="color: rgba(221, 164, 80, 1)"
            >重複{{ resdata.length }}筆。</span
          >
        </div>
      </el-row>
      <br />
      <div v-if="importGo">
        <span style="font-size: 16px">資料錯誤項目</span>
      </div>
      <div v-if="!importGo">
        <el-row>
          <span style="font-size: 20px; font-weight: bold"
            >重複資料</span
          ></el-row
        >
        <el-row>
          <span style="font-size: 16px; color: rgba(147, 147, 147, 1)"
            >以下書目資料已存在於系統中，忽略不上傳</span
          ></el-row
        >
      </div>
      <el-divider></el-divider>
      <div v-if="importGo">
        <el-table
          :data="inCorrectData"
          :cell-style="cellStyle"
          style="width: 100%"
          empty-text="無錯誤資料"
        >
          <el-table-column
            prop="status"
            label="狀態"
            width="200"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="rowi"
            label="EXCEL行數"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="書目編號"
            width="150"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bookName"
            label="書目名稱"
            width="200"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bookType"
            label="類別"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="author"
            label="作者"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
           <el-table-column
            prop="version"
            label="版本"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
     
        </el-table>
      </div>

      <!-- 回傳 -->
      <div v-if="!importGo">
        <el-table
          :data="resdata"
          :cell-style="cellStyleRes"
          style="width: 100%"
          empty-text="無重複資料"
        >
          <el-table-column
            prop="status"
            label="狀態"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="rowi"
            label="EXCEL行數"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="書目編號"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bookName"
            label="書目名稱"
            width="180"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bookType"
            label="類別"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="author"
            label="作者"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
           <el-table-column
            prop="version"
            label="版本"
            width="100"
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </el-card>
  
  </div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api/";
import { InformType } from "@/utils/InformType";

export default {
  name: "bookImport",
  components: {},
  data() {
    return {
      isLoading: false, // 是否加載數據
      outdata: null,
      fileList: [],
      tableData: [],
      total: 0,
      fieldHeads: [],
      itemKey: null,
      lcSearch: "",
      file: null,
      resdata: [],
      importGo: true,
    };
  },

  created() {
    this.importGo = true;
  },

  methods: {
    cellStyle(params) {
      // {row, column, rowIndex, columnIndex}
      if (params.row.isValid[params.column.property] == false) {
        return "background-color:rgba(229, 116, 112, 0.5);";
      }
      if (params.column.property == "status") {
        return "color:red;";
      }
      return "";
    },
    cellStyleRes(params) {
      if (params.column.property == "status")
        return "background-color:rgba(221, 164, 80, 0.3); color: rgba(221, 164, 80, 1);";
      else return "background-color:rgba(221, 164, 80, 0.3);";
    },
    // eslint-disable-next-line no-unused-vars
    handleChange(file, fileList) {
      this.importGo = true;
      this.fileData = [];
      this.total = 0;
      this.fileTemp = file.raw;
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type == "application/vnd.ms-excel"
        ) {
          // 參考網址：https://ithelp.ithome.com.tw/articles/10204718 => Promise.all 方法
          Promise.all([this.importfxx(true)]).then((res) => {
            // console.log(res[0]);
            if (res[0]) {
              // 在tableData赋值的地方，顺便随机设置下key，页面就会刷新了
              this.itemKey = Math.random();
              // console.log(
              //   "this.itemKey >> this.fieldHeads : ",
              //   this.fieldHeads
              // );
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: "上傳檔案格式錯誤,請重新上傳!",
          });
          this.fileTemp = null;
        }
      } else {
        this.$message({
          type: "warning",
          message: "Please upload the attachment!",
        });
      }
    },

    // eslint-disable-next-line no-unused-vars
    handleExceed(newFileList, oldfiles) {
      this.importGo = true;
      // 清除現有的excel檔案
      this.fileTemp = null;
      this.tableData = [];
      this.$refs["upload"].clearFiles();
      this.fileList.pop();
      // 上傳新的excel檔案
      this.fileList.push(...newFileList);
      this.handleChange(
        {
          raw: newFileList[0],
        },
        null
      );
      return;
    },

    handleRemove() {
      this.importGo = true;
      // 1. 檔案 移除
      this.fileTemp = null;
      // 2. 顯示結果移除
      this.tableData = [];
    },

    importfxx(t) {
      var outdata;
      if (t) {
        return new Promise((resolve) => {
          // Retrieving file data through DOM

          let _this = this;
          this.file = event.currentTarget.files[0];
          var reader = new FileReader();
          var rABS = false; //Read the file as a binary string
          var f = this.file;
          // if (!FileReader.prototype.readAsBinaryString) {
          FileReader.prototype.readAsBinaryString = function (f) {
            var binary = "";
            var rABS = false; //Read the file as a binary string
            var wb; //Read completed data
            var reader = new FileReader();
            reader.onload = function () {
              var bytes = new Uint8Array(reader.result);
              var length = bytes.byteLength;
              for (var i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //If not introduced in main.js, you need to introduce it here to parse excel
              // eslint-disable-next-line no-undef
              var XLSX = require("xlsx");
              if (rABS) {
                // eslint-disable-next-line no-undef
                wb = XLSX.read(btoa(fixdata(binary)), {
                  //Manual conversion
                  type: "base64",
                });
              } else {
                wb = XLSX.read(binary, {
                  type: "binary",
                  raw: true,
                });
              }

              //欄位對應
              outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
              _this.outdata = XLSX.utils.sheet_to_json(
                wb.Sheets[wb.SheetNames[0]]
              );

              _this.importCheck(outdata);
            };
            reader.readAsArrayBuffer(f);
          };
          if (rABS) {
            reader.readAsArrayBuffer(f);
          } else {
            reader.readAsBinaryString(f);
          }
          // }
          resolve(true);
        });
      } else {
        this.tableData = [];
        outdata = this.outdata;
        this.importCheck(outdata);
      }
    },

    importCheck(outdata) {
      let _this = this;
      //outdata is read data (without header rows or headers, the header will be the subscript of the object)
      //Data can be processed here.
      const label_id = "書目編號";
      const label_bookName = "書目名稱";
      const label_bookType = "類別";
      const label_author = "作者";
      const label_version = "版本";

      outdata.forEach((v, index) => {
        console.log(v);
        let obj = { isValid: {} };

        obj.rowi = index + 2;
        obj.id = `${v[label_id]}`.trim().replaceAll(/\s+/g, '');
        obj.bookName = `${v[label_bookName]}`.trim().replaceAll(/\s+/g, '');
        obj.bookType = `${v[label_bookType]}`.trim().replaceAll(/\s+/g, '');
        obj.author = `${v[label_author]}`.trim().replaceAll(/\s+/g, '');
        obj.version = `${v[label_version]}`.trim().replaceAll(/\s+/g, '');
        obj.dataCorrect = true;

        //欄位檢查

        let rulesA = new RegExp(/^\d+-\d+$/);
        let rulesB = new RegExp(/^[A-Za-z]$/);
        if (Utils.Check.isNull(v[label_id])) {
          obj.id = "";
          obj.dataCorrect = false;
          obj.isValid.id = false;
          obj.status = "書目編號資料錯誤";
        }
        if (Utils.Check.isNull(v[label_bookName])) {
          obj.bookName = "";
          obj.dataCorrect = false;
          obj.isValid.bookName = false;
          obj.status = "書目名稱資料錯誤";
        }
        if (Utils.Check.isNull(v[label_bookType])) {
          obj.bookType = "";
          obj.dataCorrect = false;
          obj.isValid.bookType = false;
          obj.status = "類別資料錯誤";
        }
        if (Utils.Check.isNull(v[label_author])) {
          obj.author = "";
          obj.dataCorrect = false;
          obj.isValid.author = false;
          obj.status = "作者資料錯誤";
        }
        if (Utils.Check.isNull(v[label_version])) {
          obj.version = "";
        }
        if (!rulesA.test(`${v[label_id]}`.trim().replaceAll(/\s+/g, ''))) {
          obj.dataCorrect = false;
          obj.isValid.id = false;
          obj.status = "編號格式錯誤";
        }
        if (!rulesB.test(`${v[label_bookType]}`.trim().replaceAll(/\s+/g, ''))) {
          obj.dataCorrect = false;
          obj.isValid.bookType = false;
          obj.status = "無效類別";
        }
        if (
          _this.tableData.findIndex((a) => a.id == `${v[label_id]}`.trim()) >= 0
        ) {
          obj.dataCorrect = false;
          obj.isValid.id = false;
          obj.status = "書目編號重複";
        }

        obj.bookName = obj.bookName.toString().replaceAll(/\s+/g, '');
     

        _this.tableData.push(obj);
      });
    },

    fileImport() {
      this.isLoading = true;
      console.log(this.correctData);
      const datas = this.correctData;
      API.book
        .importAll(datas)
        .then((res) => {
          console.log(res.data);
          this.resdata = res.data;
          this.importGo = false;
          Utils.Message.send("匯入書目成功!", InformType.SUCCESS);

          // 2. loading 結束
          this.isLoading = false;
        })
        .catch(() => {
          // 1. loading 結束
          this.isLoading = false;
        });
    },

    exportExcel() {
      let data = ["書目編號", "書目名稱", "類別", "作者", "版本"];
      Utils.Excel.example(data, "書目資料範例");
    },

    btImport() {
      if (this.dataCount > 0 && this.inCorrectData == 0 && this.importGo)
        return false;
      else return true;
    },
    back() {
      this.$router.push({ name: "書目管理" });
    },
  },

  //此段為設定只匯入有錯誤的excel欄位
  computed: {
    inCorrectData: function () {
      return this.tableData.filter((it) => it.dataCorrect == false);
    },
    correctData: function () {
      return this.tableData.filter((it) => it.dataCorrect == true);
    },
    inCorrectDataCount: function () {
      return this.tableData.filter((it) => it.dataCorrect == false).length;
    },
    correctDataCount: function () {
      return this.tableData.filter((it) => it.dataCorrect == true).length;
    },
    dataCount: function () {
      return this.tableData.length;
    },
    lifeClassSearch: function () {
      if (this.lcSearch)
        return this.lifeClass.filter((it) => it.includes(this.lcSearch));
      else return this.lifeClass;
    },
  },
};
</script>
<style scoped>
.inline-block {
  display: inline-block;
}
.margin-right-20 {
  margin-right: 20px;
}
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
.btWarning {
  background-color: #dda450;
  opacity: 0.5;
  color: #ffffff;
}
</style>
